<template>
    <div>
        <v-dialog v-model="isOpen" width="80%">
            <v-card v-if="actionLog">
                <v-card-title class="subtitle-1" primary-title>
                    {{
                        `${$t('dialogs-action-log-detail.title-prefix')}: #${
                            actionLog.id
                        }`
                    }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="isOpen = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="py-4">
                    <template>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>
                                            {{
                                                $t(
                                                    'action-log.index.table.userName',
                                                )
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                $t(
                                                    'action-log.index.table.action',
                                                )
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                $t(
                                                    'action-log.index.table.resource',
                                                )
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                $t(
                                                    'action-log.index.table.actionable_id',
                                                )
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                $t(
                                                    'action-log.index.table.actioned_at',
                                                )
                                            }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ actionLog.userName }}</td>
                                        <td>{{ actionLog.logAction }}</td>
                                        <td>{{ actionLog.resource }}</td>
                                        <td>{{ actionLog.actionable_id }}</td>
                                        <td>{{ actionLog.actioned_at }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-divider></v-divider>

                        <v-row class="mt-5">
                            <v-col>
                                <v-expansion-panels focusable>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{
                                                $t(
                                                    'action-log.index.table.original',
                                                )
                                            }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <pre
                                                v-html="original"
                                                class="py-5"
                                            ></pre>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                            <v-col>
                                <v-expansion-panels focusable>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{
                                                $t(
                                                    'action-log.index.table.changes',
                                                )
                                            }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <pre
                                                v-html="changes"
                                                class="py-5"
                                            ></pre>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false,
            actionLog: null,
            original: null,
            changes: null,
        }
    },

    methods: {
        show(actionLog) {
            this.actionLog = actionLog
            this.original = this.jsonHighlight(
                actionLog.original ? actionLog.original : {},
            )
            this.changes = this.jsonHighlight(
                actionLog.changes ? actionLog.changes : {},
            )
            this.isOpen = true
        },

        jsonHighlight(json) {
            if (typeof json != 'string') {
                json = JSON.stringify(json, undefined, 2)
            }
            json = json
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
            return json.replace(
                /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
                function(match) {
                    var cls = 'orange--text'
                    if (/^"/.test(match)) {
                        if (/:$/.test(match)) {
                            cls = 'red--text'
                        } else {
                            cls = 'green--text'
                        }
                    } else if (/true|false/.test(match)) {
                        cls = 'blue--text'
                    } else if (/null/.test(match)) {
                        cls = 'magenta--text'
                    }
                    return '<span class="' + cls + '">' + match + '</span>'
                },
            )
        },
    },
}
</script>
